import { render, staticRenderFns } from "./AccessCodeDescription.vue?vue&type=template&id=7b027df1&scoped=true&"
import script from "./AccessCodeDescription.vue?vue&type=script&lang=js&"
export * from "./AccessCodeDescription.vue?vue&type=script&lang=js&"
import style0 from "./AccessCodeDescription.vue?vue&type=style&index=0&id=7b027df1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b027df1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
